import styled from "styled-components";

const ReceivedMessage = styled.div`
  width: auto;
  min-width: 60%;
  max-width: 70%;

  border-radius: 20px;
  background-color: lightgrey;
  color: #000000;
  padding: 1%;
  margin-bottom: 1%;
`;

export default ReceivedMessage;
